package dk.smark.demo.map

data class LatLon(
    val lat: Double,
    val lon: Double
)

data class MapCameraState(
    val center: LatLon = LatLon(55.6761, 12.5683),
    val zoom: Double = 12.0,
    val bearing: Double = 0.0,
    val pitch: Double = 0.0,
)

data class MapMarker(
    val id: String,
    val position: LatLon,
    val title: String? = null,
    val isSelected: Boolean = false,
)

data class MapPolyline(
    val id: String,
    val points: List<LatLon>,
    val widthPx: Float = 4f,
)

data class MapUiState(
    val camera: MapCameraState = MapCameraState(),
    val markers: List<MapMarker> = emptyList(),
    val polylines: List<MapPolyline> = emptyList(),
    val mapReady: Boolean = false,
)